import {create} from 'zustand'

type AccountView = 'profile' | 'availability'
type EmailVerificationStatus = 'idle' | 'pending' | 'success' | 'error'
export type AccountEditingSection = 'email' | 'password' | null

type AccountStore = {
    modalView: AccountView
    editingSection: AccountEditingSection
    isAccountModalOpened: boolean
    emailVerificationStatus: EmailVerificationStatus
    setIsAccountModalOpened: (value: boolean) => void
    setEmailVerificationStatus: (value: EmailVerificationStatus) => void
    setModalView: (value: AccountView) => void
    setEditingSection: (value: AccountEditingSection) => void
}

export const useAccountStore = create<AccountStore>()(set => ({
    modalView: 'profile',
    editingSection: null,
    isAccountModalOpened: false,
    emailVerificationStatus: 'idle',
    setIsAccountModalOpened: value => set({isAccountModalOpened: value}),
    setModalView: value => set({modalView: value}),
    setEditingSection: value => set({editingSection: value}),
    setEmailVerificationStatus: value => set({emailVerificationStatus: value})
}))
